import { gpt } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
    createEmbedSession() {
        return new Promise((resolve, reject) => {
            axios
                .post(gpt.gptEmbedSessionBase, {})
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
});
